import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/components/layout/site-footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
